import React, { useState } from 'react';
import { FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa'; // <-- ÍCONE CORRIGIDO

const RelatorioAnomalias = ({ mes, anomalias, onAnomaliasResolved }) => {
    // ----------------- LÓGICA GERAL -----------------
    const hasAnomalies = anomalias && anomalias.length > 0;

    const handleResolve = () => {
        // Confirma com o usuário se ele deseja prosseguir, ignorando os alertas de anomalia.
        if (window.confirm("Você confirma que revisou as anomalias e deseja ignorar os alertas para prosseguir com o processamento?")) {
            onAnomaliasResolved();
        }
    };

    // ----------------- COMPONENTE DE ALERTA -----------------
    const AlertCard = ({ isError, message, icon }) => (
        <div
            style={{
                padding: '15px',
                borderRadius: '8px',
                backgroundColor: isError ? '#f8d7da' : '#d4edda',
                color: isError ? '#721c24' : '#155724',
                border: isError ? '1px solid #f5c6cb' : '1px solid #c3e6cb',
                marginBottom: '15px',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            {icon}
            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{message}</span>
        </div>
    );

    return (
        <div className="relatorio-anomalias">
            <h3>Verificação do Guardião de Dados para {mes}</h3>

            {/* STATUS DO ALERTA */}
            {!anomalias ? (
                <AlertCard isError={false} message="Analisando integridade dos dados..." icon={null} />
            ) : hasAnomalies ? (
                <AlertCard
                    isError={true}
                    message={`ALERTA CRÍTICO: ${anomalias.length} anomalia(s) encontrada(s).`}
                    icon={<FaExclamationTriangle />}
                />
            ) : (
                <AlertCard
                    isError={false}
                    message="Verificação concluída. Nenhuma anomalia crítica detectada."
                    icon={<FaCheckCircle />}
                />
            )}

            {/* TABELA DE DETALHES DE ANOMALIAS */}
            {hasAnomalies && (
                <>
                    <p style={{ marginTop: '20px', color: '#dc3545', fontWeight: 'bold' }}>
                        Ação Necessária: Revise os lançamentos abaixo. O processamento será bloqueado até que você confirme a revisão.
                    </p>

                    <table className="relatorio-table" style={{ fontSize: '0.9em' }}>
                        <thead>
                            <tr>
                                <th>Conta</th>
                                <th>Centro</th>
                                <th>Valor (R$)</th>
                                <th>Descrição da Anomalia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {anomalias.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.conta}</td>
                                    <td>{item.centro}</td>
                                    <td>{item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td style={{ color: '#dc3545' }}>{item.anomalia}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button
                        onClick={handleResolve}
                        className="btn-modern btn-danger mt-4"
                    >
                        Confirmar Revisão e Ignorar Alerta (Prosseguir)
                    </button>
                </>
            )}

        </div>
    );
};

export default RelatorioAnomalias;
